export class PriceRobotRule {

    id: number;
    name: string;
    is_active: boolean;
    active_start: any;
    active_end: any;
    sorting: number;
    rules_conditions: PriceRobotRuleCondition[] = [];
    rules_actions: PriceRobotRuleAction[] = [];

    constructor(id = 0, name = '', is_active = true, active_start: any = null, active_end: any = null) {
        this.id = id;
        this.name = name;
        this.is_active = is_active;
        this.active_start = active_start;
        this.active_end = active_end;
    }
}

export class PriceRobotRuleCondition {

    competitor_id: string | any[] | null;
    variant_id: string | any[] | null;
    price_change: number;
    costprice_difference: number;
    product_id: number | null;
    category_id: string | any[] | null;

    product;

    constructor(competitor = null, variant = null, priceChange = null, costpriceDifference = null, productId = null, categoryId = null) {
        this.competitor_id = competitor;
        this.variant_id = variant;
        this.price_change = priceChange;
        this.costprice_difference = costpriceDifference;
        this.product_id = productId;
        this.category_id = categoryId;
    }

}

export class PriceRobotRuleAction {

    calculated_price: boolean;
    discount_price: boolean;
    custom_price: number;
    round_price: number;
    to_watch_list: boolean;
    ignore_delivery: boolean;
    ignore_if_not_in_stock: boolean;
    ignore_price: boolean;
    adjust_price: number;

    constructor(calculatedPrice = false, discountPrice = false, customPrice = 0, roundPrice = 0, toWatchList = false, ignore_delivery = false, ignoreIfNotInStock = false, ignorePrice = false, adjustPrice = 0) {
        this.calculated_price = calculatedPrice;
        this.discount_price = discountPrice;
        this.custom_price = customPrice;
        this.round_price = roundPrice;
        this.to_watch_list = toWatchList;
        this.ignore_delivery = ignore_delivery;
        this.ignore_if_not_in_stock = ignoreIfNotInStock;
        this.ignore_price = ignorePrice;
        this.adjust_price = adjustPrice;
    }

}
